<template>
  <div>
    <div
        v-for="(card, idx) in cards"
        :key="idx"
        v-show="idx >= currentIndex && idx < currentIndex + max"
        :style="{
            zIndex: max - (idx - currentIndex),
            position: idx === currentIndex ? 'relative' : 'absolute',
            bottom: idx === currentIndex ? '0' : `-${(idx - currentIndex) * 20}px`,
            transform: idx === currentIndex ? 'scale(1)' : `scale(${1 - (idx - currentIndex) * 0.05})`,
            opacity: idx === currentIndex ? 1 : 0.7,
            pointerEvents: idx === currentIndex ? 'auto' : 'none',
          }"
        class="w-full transition-all duration-300 ease-in-out"
    >
      <component
          :is="card.component"
          :question="card.question"
          :is-current="idx === currentIndex"
          :options="getOptions(card)"
          v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CardStack",
  props: {
    cards: {type: Array, default: () => []},
    currentIndex: {type: Number, default: 0},
    progress: {type: Number, default: 0},
    showNav: {type: Boolean, default: true},
    showProgress: {type: Boolean, default: true},
    max: {type: Number, default: 3},
  },
  watch: {
    currentIndex() {
      window.scrollTo(0, 0);
    },
  },
  methods: {
    getOptions(card) {
      return {
        showBack: this.currentIndex > 0,
        showSkip: card.required === false,
        showNav: this.showNav,
        showProgress: this.showProgress,
        progress: this.progress,
        imgSrc: card.imgSrc,
      };
    },
  },
};
</script>

<style scoped>

</style>
